"use client";
import { jsx as c } from "react/jsx-runtime";
import * as e from "@radix-ui/react-checkbox";
import { forwardRef as r } from "react";
import { DEFAULT_ICON_CLASS_NAME as a } from "../../../utils/iconDefaults.mjs";
import { Check as m } from "../Icon/icons.gen.mjs";
const s = r((o, t) => /* @__PURE__ */ c(e.Root, { "data-slot": "checkbox", ...o, ref: t }));
s.displayName = "CheckboxRoot";
const d = r(({ children: o, ...t }, i) => /* @__PURE__ */ c(e.Indicator, { "data-slot": "checkbox-indicator", ...t, ref: i, children: o ?? /* @__PURE__ */ c(m, { "data-slot": "checkbox-check-icon", "aria-hidden": "true", className: a }) }));
d.displayName = "CheckboxIndicator";
export {
  d as CheckboxIndicator,
  s as CheckboxRoot
};
